import Vue from 'vue';

export enum ExpandedMediaEventBusEvents {
  ClosingFinished = 'closing_finished',
  Close = 'close',
  Play = 'play',
}

export const ExpandedMediaEventBus = new Vue();
